import { Component, OnInit, ViewEncapsulation } from '@angular/core';

import { Country } from '../../core/models/country.model';

import { ModalService } from '../../core/services/modal.service';
import { NavigationService } from '../../core/services/navigation.service';
import { SettingsService } from '../../core/services/settings.service';

export const BrowserCountryPickerModalPageIdentifier = 'browser-country-picker-modal';

@Component({
  selector: 'app-browser-country-picker-modal',
  templateUrl: 'browser-country-picker-modal.page.html',
  styleUrls: ['browser-country-picker-modal.page.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class BrowserCountryPickerModalPage implements OnInit {
  public availableCountries: Array<Country>;

  constructor(private modalService: ModalService, private navigationService: NavigationService, private settingsService: SettingsService) {}

  ngOnInit(): void {
    this.availableCountries = this.settingsService.getAvailableCountries();
  }

  public onCountryChange(country: Country): void {
    void this.dismiss().then(() => {
      if (country.code !== this.settingsService.getCountry().code) {
        void this.navigationService.navigateBackToTab(`/${country.code}/${this.settingsService.getLanguage().value}`);
      }
    });
  }

  private dismiss(): Promise<boolean> {
    return this.modalService.dismissModal({ id: BrowserCountryPickerModalPageIdentifier });
  }
}
